import { t, useLocale } from '../localization/adminText';
import { Badge, BlockStack, InlineStack, Text } from './admin-ui';

export default function CodFulfillmentHistory({ order, enabled = null, detailed = false }) {
  const locale = useLocale();
  if (order?.type !== 'cod') return null;
  const history = order.fulfillment_history;
  let status = enabled === false || history?.status === 'disabled' ? 'disabled'
    : enabled === true ? history?.status || 'unavailable' : 'unavailable';
  const countsValid = history && [history.delivered, history.refusals, history.total].every(value => Number.isInteger(value) && value >= 0)
    && history.total > 0 && history.delivered + history.refusals === history.total;
  const rateValid = typeof history?.delivery_rate === 'number' && Number.isFinite(history.delivery_rate)
    && history.delivery_rate >= 0 && history.delivery_rate <= 100;
  if (status === 'matched' && (!countsValid || !rateValid)) status = 'unavailable';
  if (status === 'disabled' && !detailed) return null;
  const rate = status === 'matched' ? new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 2 }).format(history.delivery_rate / 100) : null;
  const messages = {
    disabled: 'Delivery history reminders are disabled. Enable them in Risk management.',
    no_history: 'No matching confirmed delivery or refusal orders.',
    insufficient_identity: 'Customer details are incomplete; delivery history cannot be matched.',
    unavailable: 'Delivery history is temporarily unavailable.',
  };
  const sources = history?.sources;
  const sourceLabel = sources?.local && sources?.shared ? 'Sources: this store and reviewed shared data.'
    : sources?.local ? 'Source: this store’s order results.'
      : sources?.shared ? 'Source: reviewed shared data.'
        : 'History is checked against this store and reviewed shared data.';

  return <BlockStack gap="200">
    {detailed && <Text as="h3" variant="headingSm">{t('Fulfillment credit history')}</Text>}
    {status === 'matched' ? <>
      <InlineStack gap="200">
        {history.refusals > 0 && <Badge tone="warning">{t('Has refusal history')}</Badge>}
        {history.delivered > 0 && <Badge tone="info">{t('Has delivery history')}</Badge>}
      </InlineStack>
      <Text as="p">{t('Historical delivery rate: {0}', [rate])}</Text>
      <Text as="p" tone="subdued">{t('Delivered: {0} · Refused: {1} · Confirmed orders: {2}', [history.delivered, history.refusals, history.total])}</Text>
    </> : <Text as="p" tone="subdued">{t(messages[status] || messages.unavailable)}</Text>}
    {detailed && ['matched', 'no_history'].includes(status) && <Text as="p" tone="subdued">{t(sourceLabel)}</Text>}
    {detailed && status !== 'disabled' && <Text as="p" tone="subdued">{t('Delivery history is for review only and does not automatically block orders.')}</Text>}
    {detailed && ['matched', 'no_history'].includes(status) && history.unlinked_parcels > 0 && <Text as="p" tone="subdued">{t('{0} parcels have no identifiable order and are excluded from the delivery rate.', [history.unlinked_parcels])}</Text>}
  </BlockStack>;
}
